import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=35adfde6&scoped=true&"
import script from "./Keyboard.vue?vue&type=script&lang=js&"
export * from "./Keyboard.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard.vue?vue&type=style&index=0&id=35adfde6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35adfde6",
  null
  
)

export default component.exports